import * as React from 'react';
import { Input } from './input';

function ClearableNumberInput(props) {
  const { 
    value, 
    onChange, 
    min = 0, 
    max = 999,
    className = '',
    ...rest 
  } = props;

  const [internalValue, setInternalValue] = React.useState(String(value || ''));
  // True only while the user is typing; an external value change (e.g. a pre-filled
  // wizard) must not be echoed back, or the two effects below ping-pong forever.
  const userEditing = React.useRef(false);
  
  React.useEffect(function syncValue() {
    userEditing.current = false;
    setInternalValue(String(value || ''));
  }, [value]);

  function handleChange(e) {
    const rawValue = e.target.value;
    userEditing.current = true;
    
    if (rawValue === '') {
      setInternalValue('');
      return;
    }
    
    const cleanedValue = rawValue.replace(/^0+(?=\d)/, '');
    const numValue = parseInt(cleanedValue, 10);
    
    if (!isNaN(numValue)) {
      const clampedValue = Math.min(Math.max(numValue, min), max);
      setInternalValue(String(clampedValue));
    }
  }

  function handleBlur() {
    const numValue = parseInt(internalValue, 10);
    if (isNaN(numValue) || internalValue === '') {
      setInternalValue(String(min));
      onChange(min);
    } else {
      const clampedValue = Math.min(Math.max(numValue, min), max);
      setInternalValue(String(clampedValue));
      onChange(clampedValue);
    }
  }

  function handleFocus(e) {
    e.target.select();
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') {
      handleBlur();
    }
  }

  React.useEffect(function notifyParent() {
    if (!userEditing.current) return;
    if (internalValue !== '' && internalValue !== String(value)) {
      const numValue = parseInt(internalValue, 10);
      if (!isNaN(numValue)) {
        onChange(numValue);
      }
    }
  }, [internalValue, value, onChange]);

  return (
    <Input
      type="text"
      inputMode="numeric"
      pattern="[0-9]*"
      value={internalValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      onKeyDown={handleKeyDown}
      className={className}
      {...rest}
    />
  );
}

export { ClearableNumberInput };
export default ClearableNumberInput;
